'use client'

import React from "react";
import Link from "next/link";

import { useSelector } from "react-redux";

function ContactStylistCard() {
  const language = useSelector((state) => state.language.language);
  // console.log(language,'Selected Language')
  const text = {
    contactTitleFirst: language === "en" ? "Beauty Parlor And Salon Service At Home In" : "घर पर ब्यूटी पार्लर और सैलून सेवा",
    contactTitleSecond: language === "en" ? "Noida, Delhi, Gurugram And Bhopal" : "नोएडा, दिल्ली, गुरुग्राम और भोपाल | डीटीडीबी",
    description: language === "en" 
        ? "Our mission is to revolutionize the salon industry by expanding the reach of our skilled professionals and delivering unparalleled services directly to your home, offering an experience like never before." 
        : "हमारा मिशन सैलून उद्योग में क्रांति लाना है, जहां हम अपने कुशल पेशेवरों की पहुंच को बढ़ाकर और बेजोड़ सेवाएं सीधे आपके घर पर प्रदान करके, एक ऐसा अनुभव देते हैं जैसा पहले कभी नहीं हुआ।",
    };
  return (
    <>
    <div className="block mx-auto max-w-screen-2xl" >
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
          <div className="lg:p-2 p-2 rounded-lg">
            <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg">
              <div className="flex justify-between items-center">
                <div className="lg:w-3/5">



            <h2
                    style={{
                      fontSize: "1.4rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    className="text-lg lg:text-2xl font-bold mb-1"
                  >
                    {text.contactTitleFirst}{" "}
                    <span className="text-pink-600">{text.contactTitleSecond}</span>
                  </h2>

            
            <p className="text-lg sm:text-2xl md:text-3xl lg:text-base opacity-1200 leading-8">
              {text.description}
            </p>
            {/* <Link
              className="lg:w-1/4 hover:no-underline text-md font-medium inline-block mt-5 px-8 py-3 bg-pink-600 text-center text-white rounded-full hover:text-white hover:bg-emerald-600"
              to="/#"
            >
              Book Now
            </Link> */}
          </div>
          <div className="w-1/5 flex-grow hidden md:flex md:justify-center lg:justify-end">
            <span
              style={{
                boxSizing: "border-box",
                display: "inline-block",
                overflow: "hidden",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: "1",
                border: "1.5px",
                margin: "0px",
                padding: "0px",
                position: "relative",
                maxWidth: "100%",
              }}
            >
              <img  
  loading="lazy"  // Lazy loading added here
src="/assets/img/delivery-boy.png" style={{border: "1.5" }} alt="contact us card" className="hidden md:block" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


</>
  );
}

export default ContactStylistCard;